const isBicycle = (sku: string) => {
    const skuParts = sku.split('-');
    // Bicycle SKU always start with 101, and non-bicycle SKU can't start with 101.
    return skuParts[0] === '101' && skuParts.length >= 3;
};

export default isBicycle;
